module.exports = __webpack_public_path__ + "img/compassion.3accb559.svg";